import styled from 'styled-components';
import { Avatar, Stack } from '@optimus-web/core';
import { ANIMATION_CURVE, ANIMATION_DURATION } from '@optimus-web/common';
import { getFullName, useGetAvatarSrc } from '@mews-commander/utils';
import { selectLockedUser, useLockedUsers } from './useLockscreenStore';

const AnimatedAvatar = styled(Avatar)`
    transform: scale(1);
    transition: transform ${ANIMATION_DURATION.default}ms ${ANIMATION_CURVE.default};

    &:hover {
        transform: scale(1.2);
        cursor: pointer;
    }
`;

interface LockedUsersProps {
    onSelectLockedUser: () => void;
}

export const LockedUsers = ({ onSelectLockedUser }: LockedUsersProps) => {
    const getAvatarSrc = useGetAvatarSrc();
    const users = useLockedUsers();

    const handleSelectLockedUser = (id: string) => {
        selectLockedUser(id);
        onSelectLockedUser();
    };

    return (
        <Stack alignment="center" spacing="100">
            {Object.values(users).map(({ user }) => (
                <AnimatedAvatar
                    src={getAvatarSrc(user.imageId)}
                    title={getFullName(user)}
                    size="small"
                    onClick={() => handleSelectLockedUser(user.id)}
                    key={user.id}
                />
            ))}
        </Stack>
    );
};
